import styled from 'styled-components'

const LogoStyled = styled.img`
  height: var(--logo-height);
`

export default LogoStyled
